<script>
import { Bar } from 'vue-chartjs'
import { EventBus } from '@/EventBus'

export default {
  extends: Bar,
  props: ['data', 'options'],
  data () {
    return {
      // chartData: {
      //   type: 'bar',
      //   // labels: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน'],
      //   labels: ['ม.ค', 'ก.พ', 'มี.ค', 'เม.ย', 'พ.ค', 'มิ.ย', 'ก.ค', 'ส.ค', 'ก.ย', 'ต.ค', 'พ.ย', 'ธ.ค'],
      //   datasets: [{
      //     label: 'พนักงานภายใน',
      //     borderWidth: 1,
      //     backgroundColor: [
      //       '#3776E9',
      //       '#3776E9',
      //       '#3776E9',
      //       '#3776E9'
      //     ],
      //     borderColor: [
      //       // 'rgba(255,99,132,1)',
      //       // 'rgba(54, 162, 235, 1)',
      //       // 'rgba(255, 206, 86, 1)',
      //       // 'rgba(255, 159, 64, 1)'
      //     ],
      //     pointBorderColor: '#2554FF',
      //     data: []
      //   },
      //   {
      //     label: 'พนักงานภายนอก',
      //     borderWidth: 1,
      //     backgroundColor: [
      //       '#C7C7C7',
      //       '#C7C7C7',
      //       '#C7C7C7',
      //       '#C7C7C7'
      //     ],
      //     borderColor: [
      //       // 'rgba(255,99,132,1)',
      //       // 'rgba(54, 162, 235, 1)',
      //       // 'rgba(255, 206, 86, 1)',
      //       // 'rgba(255, 159, 64, 1)'
      //     ],
      //     pointBorderColor: '#2554FF',
      //     data: []
      //   }
      //   ]
      // },
      // options: {
      //   scales: {
      //     yAxes: [{
      //       ticks: {
      //         // min: 0,
      //         // max: 10,
      //         // stepSize: 100,
      //         reverse: false,
      //         beginAtZero: true
      //       },
      //       gridLines: {
      //         display: true
      //       }
      //     }],
      //     xAxes: [{
      //       gridLines: {
      //         display: false
      //       }
      //     }]
      //   },
      //   legend: {
      //     display: true
      //   },
      //   responsive: true,
      //   maintainAspectRatio: false,
      //   innerHeight: 20
      // }
    }
  },
  mounted () {
    // this.renderChart()
    this.render()
    EventBus.$on('barChartData', this.barChartData)
  },
  watch: {
    data (to, from) {
      this.render()
    }
  },
  methods: {
    render () {
      this.renderChart(this.data, this.options)
    }
    // barChartData (regis, resign) {
    //   console.log('value Data regis', regis)
    //   console.log('value Data resign', resign)
    //   this.chartData.datasets[0].data = [10, 2, 3, 5]
    //   this.chartData.datasets[1].data = [2, 3, 1, 5]
    //   console.log('s', this.chartData)
    // }
  }
  // created: () {

  // }
}
</script>

<style scoped>
#bar-chart{
  /* background-color: cornflowerblue; */
}
.chartjs-render-monitor {
  /* color: brown; */
  /* background-color: red; */
}
</style>
